exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-id='footer'] {\n  margin-bottom: 120px;\n}\n", ""]);
